export default __webpack_public_path__ + "static/media/pic4.db7c5b10.jpg";